import { actionCreator } from "../../lib/util/ReduxUtils";
import { TimeSelectionId } from "../../lib/util/PillarDataUtils";

/** Data */
export const setTimeRange = actionCreator<string>(
	"[DRIVER PROFILE] SET_TIME_RANGE",
);

export const setCharacteristicsTimeRange = actionCreator<TimeSelectionId>(
	"[DRIVER PROFILE] SET_CHARACTERISTICS_TIME_RANGE",
);

/** Comparison */
export const setComparisonLevels = actionCreator<string[]>(
	"[DRIVER PROFILE] SET_COMPARISON_LEVELS",
);
